
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Card, CardBody, Chip, Tabs, Tab } from "@heroui/react"

import { calculateTotalByKey, selectFilter } from "../../Utility/utility.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { ENUM_DASHBOARD_COLOR, GetLoginCredentialDb, apiRoute } from "../../constants/enum.js"
import { ErrorCard, LoadingCard, NextUITable } from "../../components/index.js"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  SELECTION_MODE,
} from "../../components/NextUITable.jsx"
import DashboardSaleNPurchaseChart from "./DashboardSaleNPurchaseChart.jsx"
import { faChartArea, faListSquares } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const filterTableFn = ({ data, columnNames, keyColumn, conditions }) => {
  let newData = data

  if (Object.values(conditions).join("")) {
    newData = selectFilter({ data: newData, conditions })
  }
  newData = calculateTotalByKey({
    data: newData,
    columnNames,
    keyColumn,
  })

  const updatedData = newData.map((ele) => {
    return { ...ele,  NetRate: (ele.NetAmount / ele.Quantity).toFixed(2) }
  })
 

 
  return updatedData
}

function DashboardSale({ propDate }) {
  const { compCode, yearId } = useSelector((state) => state.company)
  const { user } = useSelector((state) => state.auth)
  const [data, setData] = useState([])
  const [tableFilter, setTableFilter] = useState({
    "Sales/Jobwork": "",
    mnth: "",
    party: "",
    item_desc: "",
  })
  const { mnth, party, item_desc } = tableFilter
  const {
    isLoading,
    isError,
    data: saleData = [],
    mutate: funLoadData
  } = usePost({
    url: apiRoute.dashboard.getSaleData,
    queryKey: "DashboardSale",
    onSuccessTasks: (data) => {
      setData(data)

    }

  })

  useEffect(() => {
    funLoadData({
      data: {
        compcode: compCode.join(","),
        action: "OVERALL SUMMARY",
       // db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
        fromdate: propDate.start,
        todate: propDate.end
      }
    })
  }, [propDate])
  const columnNames = ["Quantity", "NetRate", "NetAmount"]

  const [selectedFilter, setSelectedFilter] = useState([])
  const [jobworkWiseData, setJobworkWiseData] = useState([])
  const [monthWiseData, setMonthWiseData] = useState([])
  const [partyWiseData, setPartyWiseData] = useState([])
  const [productWiseData, setProductWiseData] = useState([])


  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "Sales/Jobwork",
      conditions: { mnth, party, item_desc },
    })
    setJobworkWiseData(newData)
  }, [data, mnth, party, item_desc])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "mnth",
      conditions: {
        "Sales/Jobwork": tableFilter["Sales/Jobwork"],
        party,
        item_desc,
      },
    })
    setMonthWiseData(newData)
  }, [data, tableFilter["Sales/Jobwork"], party, item_desc])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "party",
      conditions: {
        "Sales/Jobwork": tableFilter["Sales/Jobwork"],
        mnth,
        item_desc,
      },
    })
    setPartyWiseData(newData)
  }, [data, tableFilter["Sales/Jobwork"], mnth, item_desc])

  useEffect(() => {
    const newData = filterTableFn({
      data,
      columnNames,
      keyColumn: "item_desc",
      conditions: {
        "Sales/Jobwork": tableFilter["Sales/Jobwork"],
        mnth,
        party,
      },
    })
    setProductWiseData(newData)
  }, [data, mnth, tableFilter["Sales/Jobwork"], party])

  let tables = [
    {
      columns: [
        {
          uid: "Sales/Jobwork",
          name: "Sales / Jobwork",
          sortable: true,
          textcolor: ENUM_DASHBOARD_COLOR.jobWork,
        },
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "Sales/Jobwork",
        "NetAmount",
        "Quantity",
        "NetRate",
      ],
      downloadFileName: "Sale_Data_Sale_Jobwork",
      data: jobworkWiseData,
      id: "Sales/Jobwork",
      // resetSelectedKeys: selectedKeysReset["Sales/Jobwork"],
    },
    {
      columns: [
        {
          uid: "mnth",
          name: "month",
          sortable: true,
          textcolor: ENUM_DASHBOARD_COLOR.Month,
        },
        
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["mnth", "NetAmount", "Quantity", "NetRate"],
      downloadFileName: "Sale",
      data: monthWiseData,
      id: "mnth",
      // resetSelectedKeys: selectedKeysReset["mnth"],
    },
    {
      columns: [
        { uid: "party", name: "Party Name", sortable: true, textcolor: ENUM_DASHBOARD_COLOR.Party },
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,

        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: ["party", "NetAmount", "Quantity", "NetRate"],
      downloadFileName: "Sale_Data_Party",
      data: partyWiseData,
      id: "party",
      // resetSelectedKeys: selectedKeysReset["party"],
    },
    {
      columns: [
        { uid: "item_desc", name: "Item / Product", sortable: true, textcolor: ENUM_DASHBOARD_COLOR.Product },
        {
          uid: "NetAmount",
          name: "netAmount",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "Quantity",
          name: "quantity",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
        {
          uid: "NetRate",
          name: "netRate",
          sortable: true,
          align: COLUMN_ALIGN_TYPE.center,
          type: COLUMN_TYPE.number,
        },
      ],
      INITIAL_VISIBLE_COLUMNS: [
        "item_desc",
        "NetAmount",
        "Quantity",
        "NetRate",
      ],
      downloadFileName: "Sale_Data_Item_Product",
      data: productWiseData,
      id: "item_desc",
      resetSelectedKeys: false,
      // resetSelectedKeys: selectedKeysReset["item_desc"],
    },
  ]

  const topActionFilter = []

  const handleSelectionChange = ({ e, column }) => {
    if (e.size > 0) {
      let val = Array.from(e)[0]
      let newSelectedFilter = { key: column, value: val }

      if (!selectedFilter.find((obj) => obj.key === column)) {
        // column does not exist
        setSelectedFilter((prev) => [...prev, newSelectedFilter])
      } else {
        // column exist, but key changed
        setSelectedFilter((prev) =>
          prev.map((obj) => (obj.key === column ? newSelectedFilter : obj))
        )
      }

      setTableFilter((prev) => ({
        ...prev,
        [column]: val,
      }))
    } else {
      setSelectedFilter((prev) => prev.filter((item) => item.key !== column))
      setTableFilter((prev) => ({
        ...prev,
        [column]: "",
      }))
    }
  }

  const handleCloseSelectedFilter = (columnToRemove) => {
    setSelectedFilter(
      selectedFilter.filter((item) => item.key !== columnToRemove)
    )
    setTableFilter((prev) => ({
      ...prev,
      [columnToRemove]: "",
    }))


    if (selectedFilter.length === 1) {
      setSelectedFilter([])
    }
  }


  function SelectedFilter() {
    return (

      <div className="flex flex-wrap gap-2 mb-2">
        {selectedFilter.map((item, index) => (
          <Chip
            key={index}
            onClose={() => handleCloseSelectedFilter(item?.key)}
            color="primary"
            variant="solid"
            size="sm"
          >
            <div className="flex gap-2 items-center p-1">
              <span className="uppercase">{item?.key.replace("_", " ")}</span>
              <span className="bg-white text-primary p-0.5 rounded-md text-xs">
                {item?.value}
              </span>
            </div>
          </Chip>
        ))}
      </div>
    )
  }

  if (isLoading) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  // const
  return (
    <div>
      <SelectedFilter />
      <Tabs
  aria-label="tabs"
  variant="solid"
  radius="full"
  color="primary"
  classNames={{
    tabList:
    "bg-emerald-50 rounded-2xl p-1 border border-emerald-200 shadow-sm gap-2",

  cursor:
    "bg-gradient-to-r from-emerald-500 to-green-600 rounded-xl shadow-md",

  tab:
    "h-8 px-6 transition-all duration-300 data-[hover=true]:bg-emerald-100",

  tabContent:
    "group-data-[selected=true]:text-white font-semibold text-sm",
  }}
>
  <Tab
    key="purchase"
    title={
      <div className="flex items-center gap-3">

        <div
          className="
            flex
            h-8
            w-8
            items-center
            justify-center
            rounded-full
            bg-white
            shadow-sm
          "
        >
          <FontAwesomeIcon
            icon={faListSquares}
            className="text-emerald-600 text-sm"
          />
        </div>

        <span>Data</span>

      </div>
    }
  >
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {tables.map((table, index) => (
        <Card
          key={index}
          className="border border-slate-200 shadow-sm hover:shadow-md transition-shadow"
        >
          <CardBody className="p-3">
            <NextUITable
              INITIAL_VISIBLE_COLUMNS={table.INITIAL_VISIBLE_COLUMNS}
              data={table.data}
              columns={table.columns}
              downloadFileName={table.downloadFileName}
              id={table.id}
              rowSelection={true}
              selectionMode={SELECTION_MODE.single}
              showTopContent={false}
              showFooter={false}
              showPagination={false}
              topActionFilter={topActionFilter}
              handleSelectionChange={handleSelectionChange}
            />
          </CardBody>
        </Card>
      ))}
    </div>
  </Tab>

  <Tab
    key="chart"
    title={
      <div className="flex items-center gap-3">

        <div
          className="
            flex
            h-8
            w-8
            items-center
            justify-center
            rounded-full
            bg-white
            shadow-sm
          "
        >
          <FontAwesomeIcon
            icon={faChartArea}
            className="text-emerald-600 text-sm"
          />
        </div>

        <span>Charts</span>

      </div>
    }
  >
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <DashboardSaleNPurchaseChart
        isSaleChart={true}
        dataFilter={selectedFilter}
        dataMonth={monthWiseData}
        dataJobWork={jobworkWiseData}
        dataParty={partyWiseData}
        dataProduct={productWiseData}
      />
    </div>
  </Tab>
</Tabs>
    </div>
  )
}
export default DashboardSale


//  <Tabs aria-label="tabs" color="danger" radius="none" className="" variant="bordered" >

//         <Tab className="text-sm " key="purchase" title={
//            <div className="flex  items-center space-x-2">
//                                         <FontAwesomeIcon  className="bg-rose-200 p-2 rounded-full text-slate-700" icon={faListSquares} />
//                                         <span>Data</span>
//                                       </div>
//         }>
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
//             {/* selected filter chip */}
//             {/* table */}
//             {tables.map((table, index) => {
//               return (
//                 <Card key={index}>
//                   <CardBody>
//                     <NextUITable
//                       INITIAL_VISIBLE_COLUMNS={table.INITIAL_VISIBLE_COLUMNS}
//                       data={table.data}
//                       columns={table.columns}
//                       downloadFileName={table.downloadFileName}
//                       id={table.id}
//                       rowSelection={true}
//                       selectionMode={SELECTION_MODE.single}
//                       showTopContent={false}
//                       showFooter={false}
//                       showPagination={false}
//                       topActionFilter={topActionFilter}
//                       handleSelectionChange={handleSelectionChange}
//                     />
//                   </CardBody>
//                 </Card>
//               )
//             })}
//             {/* end of table */}
//           </div>
//         </Tab>
//         <Tab className="text-sm" key="chart" title={
//            <div className="flex  items-center space-x-2">
//                                         <FontAwesomeIcon  className="bg-rose-200 p-2 rounded-full text-slate-700" icon={faChartArea} />
//                                         <span>Charts</span>
//                                       </div>
//         } >

//           <DashboardSaleNPurchaseChart isSaleChart={true} dataFilter={selectedFilter} dataMonth={monthWiseData} dataJobWork={jobworkWiseData} dataParty={partyWiseData} dataProduct={productWiseData} />

//         </Tab>
//       </Tabs>